var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoomAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.653V8.801L8.013 2.362L15.5 8.299V12.653L8 15.466L0.5 12.653Z",
    fill: "#F5CE85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.025 3.00999L15 8.54099V12.307L8 14.932L1 12.307V9.03099L8.025 3.00999ZM8 1.71399L0 8.57099V13L8 16L16 13V8.05699L8 1.71399Z",
    fill: "#967A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.466L0.5 12.278V3.347L8 0.533997L15.5 3.347V12.278L8 9.466Z",
    fill: "#B5DDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.068L15 3.693V11.557L8.351 9.064L8 8.932L7.649 9.064L1 11.557V3.693L8 1.068ZM8 0L0 3V13L8 10L16 13V3L8 0Z",
    fill: "#7496C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.557L8 8.93199V1.06799L15 3.69299V11.557Z",
    fill: "#E6F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.403V4.729L12.5 5.502V11.153L10.5 10.403Z",
    fill: "#FFC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.459L12 5.845V10.432L11 10.057V5.459ZM10 4V10.75L13 11.875V5.16L10 4Z",
    fill: "#A16A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.301L6.5 3.733V7.665L2.5 9.158V5.301Z",
    fill: "#8BB7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4.466V7.317L3 8.437V5.642L6 4.466ZM7 3L2 4.96V9.878L7 8.012V3Z",
    fill: "#4E7AB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7C10.3065 7 9.16193 7.47411 8.31802 8.31802C7.47411 9.16193 7 10.3065 7 11.5C7 12.6935 7.47411 13.8381 8.31802 14.682C9.16193 15.5259 10.3065 16 11.5 16C12.6935 16 13.8381 15.5259 14.682 14.682C15.5259 13.8381 16 12.6935 16 11.5C16 10.3065 15.5259 9.16193 14.682 8.31802C13.8381 7.47411 12.6935 7 11.5 7Z",
    fill: "#5E9C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9H12V14H11V9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11H14V12H9V11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomAdd);
export default __webpack_public_path__ + "static/media/room--add.1d0a891036bdfab2d39deea61bd1b4fb.svg";
export { ForwardRef as ReactComponent };